import { Grid, Paper } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'

import moment from 'moment'

import { ptBR } from 'date-fns/locale'
import { DateRangePickerCalendar, START_DATE } from 'react-nice-dates'
import 'react-nice-dates/build/style.css'

import Context from '../../context'
import useStyles from './styles'

function DashboardCalendar() {
  const classes = useStyles()
  const { rangeDate, setRangeDate } = useContext(Context)

  const [sameDay, setSameDay] = useState(true)

  const [startDate, setStartDate] = useState(rangeDate[0])
  const [endDate, setEndDate] = useState(rangeDate[1])
  const [focus, setFocus] = useState(START_DATE)

  useEffect(() => {
    setSameDay(
      moment(rangeDate[0]).format('DD/MM').toString() ===
        moment(rangeDate[1]).format('DD/MM').toString()
    )
  }, [rangeDate])

  const handleFocusChange = newFocus => {
    setFocus(newFocus || START_DATE)
  }

  useEffect(() => {
    setRangeDate([startDate, endDate])
  }, [startDate, endDate])

  return (
    <Paper elevation={0} className={classes.root}>
      {sameDay ? (
        <>
          <Grid className={classes.dashText}>
            {moment(rangeDate[0]).format('dddd').toString().toUpperCase()}
          </Grid>
          <Grid className={classes.dashDate}>
            {moment(rangeDate[0]).format('DD/MM').toString()}
          </Grid>
        </>
      ) : (
        <Grid className={classes.dashDateRange}>
          {`${moment(rangeDate[0]).format('DD/MM').toString()} - ${moment(rangeDate[1])
            .format('DD/MM')
            .toString()}`}
        </Grid>
      )}

      <div style={{ width: '100%' }}>
        <DateRangePickerCalendar
          startDate={startDate}
          endDate={endDate}
          focus={focus}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
          onFocusChange={handleFocusChange}
          locale={ptBR}
        />
      </div>
    </Paper>
  )
}

export default DashboardCalendar
